// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
export type UserManagementRequestEmailVerificationMutationInput = {
  clientMutationId?: string | null | undefined;
  language?: string | null | undefined;
  linkDomain?: string | null | undefined;
  site?: string | null | undefined;
};

export type RequestEmailVerificationMutationVariables = Exact<{
  input: Types.UserManagementRequestEmailVerificationMutationInput;
}>;


export type RequestEmailVerificationMutation = { userManagementRequestEmailVerification: { success: boolean | undefined, errors: Array<{ message: string | undefined, params: Array<{ name: string | undefined, value: string | undefined } | undefined> | undefined } | undefined> | undefined } | undefined };


export const RequestEmailVerificationMutationDocument = gql`
    mutation RequestEmailVerificationMutation($input: UserManagementRequestEmailVerificationMutationInput!) {
  userManagementRequestEmailVerification(input: $input) {
    success
    errors {
      message
      params {
        name
        value
      }
    }
  }
}
    `;